import React, { useState, useEffect } from 'react';

import useAsync from '../hooks/useAsync';
import ContactServices from '../services/ContactServices';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // Import React Quill styles

function CanclePolicy() {
  const { data, error, isLoading } = useAsync(ContactServices.getCancel);

  
  const [formValues, setFormValues] = useState({
    cancelPolicy: '',
    cancelPolicyTitle: '',
    data: "cancelPolicy"
  });

  useEffect(() => {
    if (data) {
      setFormValues({
        cancelPolicyTitle: data?.data?.Title || '',
        cancelPolicy: data?.data?.English || '',
        data: "cancelPolicy"
      });
    }
  }, [data]);

  const handleInputChange = (name, value) => {
    setFormValues(prevValues => ({ ...prevValues, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await ContactServices.updateAppPolicy(formValues);
     
      alert('Cancle Policy updated successfully!');
    } catch (error) {
      console.error('Failed to update Cancle Policy:', error);
      alert('Failed to update Cancle Policy. Please try again.');
    }
  };

  return (
    <div className="right_col" role="main">
        <div className="title-box">
          <h2>Cancellation Policy</h2>
        </div>
      <div className="container-box p-4 profile-container">
        <div className="container-box-inner table-reponsive-tabe">
          <div className="row page-details">
            <form onSubmit={handleSubmit}>
              <div className="input-field">
                <label>Title</label>
                <input
                  type="text"
                  name="title"
                  value={formValues.cancelPolicyTitle}
                  onChange={(e) => handleInputChange('cancelPolicyTitle', e.target.value)}
                  placeholder="Enter Title"
                  className="form-control"
                />
              </div>
          
              <div className="input-field">
                <label>Descriptions</label>
                <ReactQuill
                  theme="snow"
                  value={formValues.cancelPolicy}
                  onChange={(value) => handleInputChange('cancelPolicy', value)}
                />
              </div>
              <button className="submit-green-btn">SUBMIT</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CanclePolicy;
